import { render } from "./upload-form.vue?vue&type=template&id=082e249b&scoped=true&ts=true"
import script from "./upload-form.vue?vue&type=script&lang=ts"
export * from "./upload-form.vue?vue&type=script&lang=ts"

import "./upload-form.vue?vue&type=style&index=0&id=082e249b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-082e249b"]])

export default __exports__